import ArtistAuctionRecordRates from "./ArtistAuctionRecordRates";

export default ArtistAuctionRecordRates;
